import { validateWorkspaceSearch, type WorkspaceSearch } from "./workspaceSearch.js";

export const PROTECTED_PATHS = ["/focus", "/work", "/graph", "/documents"] as const;
export type ProtectedPath = (typeof PROTECTED_PATHS)[number];

export type ProtectedDestination = {
  readonly to: ProtectedPath;
  readonly search: WorkspaceSearch;
};

const DEFAULT_DESTINATION: ProtectedDestination = { to: "/focus", search: {} };
let pendingDestination: ProtectedDestination | null = null;

function isProtectedPath(pathname: string): pathname is ProtectedPath {
  return PROTECTED_PATHS.some((candidate) => candidate === pathname);
}

export function rememberProtectedDestination(input: {
  readonly pathname: string;
  readonly search: unknown;
}): boolean {
  if (!isProtectedPath(input.pathname)) return false;

  try {
    pendingDestination = {
      to: input.pathname,
      search: validateWorkspaceSearch(input.search),
    };
    return true;
  } catch {
    return false;
  }
}

export function takeProtectedDestination(): ProtectedDestination {
  const destination = pendingDestination ?? DEFAULT_DESTINATION;
  pendingDestination = null;
  return destination;
}

export function clearProtectedDestination(): void {
  pendingDestination = null;
}
